"use client";

import React, { createContext } from "react";
import { RouterOutputs, api } from "@/lib/trpc/client";
import posthog from "posthog-js";
type StateType = RouterOutputs["auth"]["me"] | undefined;
const initialState: StateType = undefined;
export const Auth = createContext<StateType>(initialState);
export const AuthProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    data
  } = api.auth.me.useQuery(undefined, {
    retry: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false
  });
  React.useEffect(() => {
    if (data) {
      posthog.identify(data.id, {
        email: data.email,
        institutionName: data.institution?.name,
        institutionId: data.institution?.id
      });
    }
  }, [data]);
  return <Auth.Provider value={data} data-sentry-element="unknown" data-sentry-component="AuthProvider" data-sentry-source-file="Auth.tsx">{children}</Auth.Provider>;
};